import { ErrorHandler } from '@shared/error-handler-legacy';

export default ErrorHandler;
